import { Account } from '../models/account';

class AccountService {
	getAccount() {
		const accountStr = localStorage.getItem('ACCOUNT');
		if (accountStr) {
			return JSON.parse(accountStr) as Account;
		}
		return undefined;
	}

	setAccount(account: Account) {
		localStorage.setItem('ACCOUNT', JSON.stringify(account));
	}

	logout() {
		localStorage.removeItem('ACCOUNT');
	}

	getFCMToken() {
		return localStorage.getItem('FCM_TOKEN');
	}

	setFCMToken(token: string) {
		localStorage.setItem('FCM_TOKEN', token);
	}

	setProfileCreated() {
		localStorage.setItem('PROFILE_CREATED', 'true');
	}

	resetProfileCreated() {
		localStorage.removeItem('PROFILE_CREATED');
	}

	isProfileCreated() {
		return localStorage.getItem('PROFILE_CREATED') === 'true';
	}
}

export default new AccountService();
